"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerDropdownInputFieldItem = void 0;

var _itemRegistry = require("../../../../core/registry/item-registry");

var _dropdownInputFieldFactory = require("./dropdown-input-field-factory");

var _dropdownInputFieldRenderer = require("./dropdown-input-field-renderer");

var registerDropdownInputFieldItem = function registerDropdownInputFieldItem() {
  (0, _dropdownInputFieldRenderer.registerDropdownInputElement)();
  (0, _itemRegistry.registerItem)('dropdown-input-field', {
    factory: _dropdownInputFieldFactory.BmDropdownInputInfoFactory,
    renderer: _dropdownInputFieldRenderer.renderDropdownInputItem
  });
};

exports.registerDropdownInputFieldItem = registerDropdownInputFieldItem;
